import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/client";
import { resolveApiUrl } from "./resolveApiUrl";

const configuredAuthBaseUrl = resolveApiUrl("/api/auth");
const authBaseUrl =
  /^https?:\/\//i.test(configuredAuthBaseUrl) || typeof window === "undefined"
    ? configuredAuthBaseUrl
    : new URL(configuredAuthBaseUrl, window.location.origin).toString();

export const authClient = createAuthClient({
  baseURL: authBaseUrl,
  fetchOptions: {
    credentials: "include"
  },
  plugins: [passkeyClient()]
});
